import { createSelector } from '@ngrx/store';
import * as fromErrorHandler from './error-handler.reducer';

export const { selectError, selectErrorHandlerState } =
  fromErrorHandler.errorHandlerFeature;

export const selectValidationErrors = createSelector(selectError, (error) => {
  if (error?.status === 422) {
    return error?.error?.errors as null | Record<string, string[]>;
  }

  return null;
});

export const selectErrorMessage = createSelector(selectError, (error) => {
  return error?.error?.message ?? error?.message ?? 'Error';
});
